import { DEPARTMENTS } from '../enums/enums';
import { DeptEntityId } from '../types';
import { characterCompare } from '@synconset/sorting';

export function getInventoryComplexId({
	department,
	id,
}: DeptEntityId): string {
	return `${DEPARTMENTS[department]}.${id}`;
}

export function sortInventoryByCloset(inventoryWithCharacters, sortOrder) {
	const charIsUndefined = (x) =>
		(x.char_num === '' || x.char_num === undefined) &&
		!x.first_name &&
		!x.last_name;
	const charIsTBD = (x) =>
		(x.char_num === '' || x.char_num === null) && (x.first_name || x.last_name);
	const charIsMulti = (x) => {
		let result =
			isNaN(x.char_num) &&
			(x.char_num === 'MULTI' ||
				x.char_num === 'Multi' ||
				x.char_num === 'multi') &&
			!(x.char_num === '');
		return result;
	};

	inventoryWithCharacters.map((x) => {
		if (!x.db_char_num) x.db_char_num = x.epChar ? x.epChar.char_num : null;
		x.char_type_rank =
			!x.epChar || charIsUndefined(x.epChar)
				? 9999
				: !x.epChar.is_primary
				? 111
				: charIsTBD(x.epChar)
				? 777
				: charIsMulti(x.epChar)
				? 888
				: 999;
	});

	const sortRank = (a, b) => {
		const rankResult = b['char_type_rank'] - a['char_type_rank'];
		if (rankResult !== 0) {
			return rankResult;
		}
		return characterCompare(a.epChar, b.epChar);
	};

	let sorted = inventoryWithCharacters.sort(sortRank);

	return sortOrder === 'asc' ? sorted : [...sorted].reverse();
}
